"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayContainer = exports.OverlayContext = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var react_dom_1 = require("react-dom");

var components_utils_1 = require("@conte-ltd/components-utils");

var components_animation_1 = require("@conte-ltd/components-animation");

var overlays_1 = require("@react-aria/overlays");

var ssr_1 = require("@react-aria/ssr");

exports.OverlayContext = (0, react_2.createContext)(null);

function _OverlayContainer(props, fwRef) {
  var _children = props.children,
      _a = props.isPreventScroll,
      isPreventScroll = _a === void 0 ? false : _a,
      _b = props.isAutoClose,
      isAutoClose = _b === void 0 ? false : _b,
      _c = props.autoCloseTime,
      autoCloseTime = _c === void 0 ? 5000 : _c,
      _d = props.isOpen,
      isOpen = _d === void 0 ? false : _d,
      onClose = props.onClose,
      options = props.options,
      keyframes = props.keyframes,
      portalContainer = props.portalContainer;

  var _e = __read((0, react_2.useState)(isOpen), 2),
      isOpenDuringFade = _e[0],
      setIsOpenDuringFade = _e[1];

  var overlayRef = (0, react_2.useRef)(null);

  var _f = (0, overlays_1.useOverlay)(__assign({}, props), overlayRef),
      overlayProps = _f.overlayProps,
      underlayProps = _f.underlayProps;

  var _g = (0, components_animation_1.useAnimationController)(),
      animationRef = _g.ref,
      play = _g.play,
      updatePlaybackRate = _g.updatePlaybackRate;

  var modalProviderProps = (0, overlays_1.useModalProvider)().modalProviderProps;
  var isSSR = (0, ssr_1.useIsSSR)();
  (0, overlays_1.usePreventScroll)({
    isDisabled: !isPreventScroll || !isOpen
  });
  (0, react_2.useEffect)(function () {
    if (isOpen) {
      setIsOpenDuringFade(true);
    } else {
      updatePlaybackRate(-1);
      play();
    }
  }, [isOpen]);
  (0, react_2.useEffect)(function () {
    if (isOpenDuringFade) {
      updatePlaybackRate(1);
      play();
    }
  }, [isOpenDuringFade]);

  if (isAutoClose) {
    var _h = (0, components_utils_1.useTimeout)(function () {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }, autoCloseTime, {
      manualMode: true
    }),
        set_1 = _h.set,
        clear_1 = _h.clear;

    (0, react_2.useEffect)(function () {
      if (isOpen) {
        set_1();
      } else {
        clear_1();
      }
    }, [isOpen]);
  }

  return isSSR ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0) : (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(overlays_1.ModalProvider, {
    children: isOpenDuringFade ? (0, jsx_runtime_1.jsx)(components_animation_1.Animation, __assign({
      fadeIn: true,
      keyframes: keyframes,
      options: __assign({
        duration: 200
      }, options),
      onUpdate: function onUpdate(_a) {
        var playState = _a.playState;

        if (playState === 'finished' && !isOpen) {
          setIsOpenDuringFade(false);
        }
      },
      ref: animationRef
    }, {
      children: function children(_a) {
        var ref = _a.ref;
        return (0, jsx_runtime_1.jsx)("div", __assign({
          css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                  position: relative;\n                  z-index: 1000;\n                "], ["\n                  position: relative;\n                  z-index: 1000;\n                "]))),
          ref: (0, components_utils_1.mergeRefs)([fwRef, ref])
        }, (0, components_utils_1.mergeProps)(modalProviderProps, underlayProps, (0, components_utils_1.styleProps)(props)), {
          children: (0, jsx_runtime_1.jsx)(exports.OverlayContext.Provider, __assign({
            value: {
              isOpen: isOpen,
              onClose: onClose,
              overlayProps: overlayProps,
              ref: overlayRef
            }
          }, {
            children: _children
          }), void 0)
        }), void 0);
      }
    }), void 0) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0)
  }, void 0), portalContainer !== null && portalContainer !== void 0 ? portalContainer : document.body);
}

exports.OverlayContainer = (0, react_2.forwardRef)(_OverlayContainer);
var templateObject_1;